import React from 'react';
import _ from 'lodash';
import { AnalyticsSimpleTile } from '../AnalyticsSimpleTile/AnalyticsSimpleTile';
import LocationChartWrapper from '../../../components/Charts/LocationChartWrapper';
import { AnalyticsPopupTile } from '../AnalyticsPopupTile/AnalyticsPopupTile';
import { AnalyticsSimpleTileCollapser } from '../AnalyticsSimpleTile/AnalyticsSimpleTileCollapser';

export class AnalyticsLocationTile extends React.Component {

    shouldComponentUpdate(nextProps) {
        if (this.props.report?.data?.locationStatsDataUpdateTs !== nextProps.report?.data?.locationStatsDataUpdateTs) {
            return true;
        }
        if (JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)) {
            return true;
        }
        return false;
    }

    getHeaderStats(chartData) {
        let users = 0;
        let connections = 0;
        let interactions = 0;
        if (chartData) {
            for (let i = 0; i < chartData.length; i++) {
                let curStatRow = chartData[i];
                users += +curStatRow.deviceCount;
                connections += +curStatRow.connections;
                interactions += +curStatRow.interactions;
            }
        }
        return {
            users,
            connections,
            interactions
        };
    }

    render() {
        const locationStats = this.props.report?.data?.locationStats?.data;
        const { users, connections, interactions } = this.getHeaderStats(locationStats);

        return (
            <AnalyticsSimpleTile {...this.props} >
                <div className="analytic-tile">
                    <AnalyticsSimpleTileCollapser {...this.props}>
                        <div className="analytic-tile_header">
                            Users by locations
                        </div>
                    </AnalyticsSimpleTileCollapser>
                    <div className={`location-chart_header_stats ${_.isArray(locationStats) && 'visible-with-opacity'}`}>
                        <span className="location-chart_header_stats_label">Users:</span>
                        <span className="location-chart_header_stats_value">{users}</span>
                        <span className="location-chart_header_stats_sep" />
                        <span className="location-chart_header_stats_legend" style={{ backgroundColor: (interactions === connections && connections !== 0) ? '#FF4A4A' : '#2200ff' }} />
                        <span className="location-chart_header_stats_label">Connections:</span>
                        <span className="location-chart_header_stats_value">{connections}</span>
                        <span className="location-chart_header_stats_sep" />
                        <span className="location-chart_header_stats_legend" style={{ backgroundColor: '#FF4A4A' }} />
                        <span className="location-chart_header_stats_label">Voice Interactions:</span>
                        <span className="location-chart_header_stats_value">{interactions}</span>
                    </div>

                    <LocationChartWrapper
                        {...this.props}
                        locationStats={locationStats}
                    />
                </div>
            </AnalyticsSimpleTile>
        );
    }
}

export default AnalyticsPopupTile(AnalyticsLocationTile);